import { LocationProvider } from '@gatsbyjs/reach-router';
import { ThemeProvider } from '@mui/material';
import React from 'react';
import { QueryParamProvider } from 'use-query-params';
import { ReachAdapter } from 'use-query-params/adapters/reach';
import { theme } from '../theme/mui-theme';
import { ReferenceCodeProvider } from './ReferenceCodeProvider';

export const RootProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [hydrated, setHydrated] = React.useState(false);
  React.useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <LocationProvider>
        <QueryParamProvider adapter={ReachAdapter}>
          <ReferenceCodeProvider>{children}</ReferenceCodeProvider>
        </QueryParamProvider>
      </LocationProvider>
    </ThemeProvider>
  );
};
